module.exports = __webpack_public_path__ + "static/media/cancel.05dbbc00.svg";